import React, { ReactNode } from 'react'
import './Modal.css'

export type Props = {
  children: ReactNode
  [key: string]: any
}

export function ModalBody(props: Props) {
  const { children, ...rest } = props

  return (
    <div className="modal-body" {...rest}>
      {children}
    </div>
  )
}

export default ModalBody
